module.exports = __webpack_public_path__ + "static/media/logo-inputs.67810149.png";